export const fontQuicksand = (fs=1.2,lh, fw=5,unit='rem') => {
    return `
      font-size: ${fs*(unit == "px" ? 10 : 1)}${unit};
      line-height: ${lh ? lh*(unit == "px" ? 10 : 1)+unit: "normal"};
      font-weight: ${fw*100};
      font-family: "Quicksand", 'Helvetica','Arial','sans-serif';
      font-style: normal;
    `
}

export const styledFont = (fontStyle,fs=1.2,lh, fw=5,unit='rem') =>{
  return `
      font-size: ${fs*(unit == "px" ? 10 : 1)}${unit};
      line-height: ${lh ? lh*(unit == "px" ? 10 : 1)+unit: "normal"};
      font-weight: ${fw*100};
      font-family: ${fontStyle}, 'Helvetica','Arial','sans-serif';
      font-style: normal;
    `
}